import UiSection from "../box/UiSection";
import { RichTextBox } from "../richtext/RichTextBox";

export const ProductNote = ({ d }: { d?: ProductDetailResponse }) => {
  if (!d?.noteContent) return null;
  return (
    <UiSection title={""}>
      {/* <div dangerouslySetInnerHTML={Utils.createMarkup(d?.noteContent)} /> */}
      {d?.noteContent && <RichTextBox richtext={d?.noteContent} />}
    </UiSection>
  );
};
